export default __webpack_public_path__ + "images/gutters02.jpg";